/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerRaiseMutationResponse,
  TelegramProductsUserControllerRaisePathParams,
  TelegramProductsUserControllerRaise400,
  TelegramProductsUserControllerRaise401,
  TelegramProductsUserControllerRaise402,
  TelegramProductsUserControllerRaise404,
} from '../../types/TelegramProductsUserControllerRaise.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserRaise } from '../../methods/telegramProductsUserRaise.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserRaiseMutationKey = () => [{ url: '/api/user/telegram/products/raise/:id' }] as const;

export type TelegramProductsUserRaiseMutationKey = ReturnType<typeof telegramProductsUserRaiseMutationKey>;

/**
 * {@link /api/user/telegram/products/raise/:id}
 */
export function useTelegramProductsUserRaise<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerRaiseMutationResponse,
      ResponseErrorConfig<
        | TelegramProductsUserControllerRaise400
        | TelegramProductsUserControllerRaise401
        | TelegramProductsUserControllerRaise402
        | TelegramProductsUserControllerRaise404
      >,
      { id: TelegramProductsUserControllerRaisePathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserRaiseMutationKey();

  return useMutation<
    TelegramProductsUserControllerRaiseMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerRaise400
      | TelegramProductsUserControllerRaise401
      | TelegramProductsUserControllerRaise402
      | TelegramProductsUserControllerRaise404
    >,
    { id: TelegramProductsUserControllerRaisePathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramProductsUserRaise(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
